import { ConversationResponseSchema } from '@sweetistics/contracts';
import { mapValues } from 'es-toolkit';
import { TweetFromApiSchema } from './tweets';

// Conversation API response boundary schema
// Reuses the shared contract and materializes tweets into Tweet domain objects
export const ConversationResponseFromApiSchema = ConversationResponseSchema.transform((payload) => ({
  ...payload,
  tweets: mapValues(payload.tweets, (tweet) => TweetFromApiSchema.parse(tweet)),
}));

export type ConversationResponseFromApi = (typeof ConversationResponseFromApiSchema)['_output'];
